module.exports = "images/beardman-climb-3-3364872a5263018a042afa9d5fab9c7e.png";